import PropTypes from 'prop-types';
import { createContext } from 'react';
const ObjectTypePropertiesContext = /*#__PURE__*/createContext({
  // Note: These should be moved to a different context, but keeping it here for
  //   now to simplify component composition.
  embedId: '',
  isEmbedded: false,
  supportsCustomProperties: () => false
});
ObjectTypePropertiesContext.Provider.propTypes = {
  value: PropTypes.shape({
    isEmbedded: PropTypes.bool.isRequired,
    supportsCustomProperties: PropTypes.func.isRequired
  })
};
export const ObjectTypePropertiesProvider = ObjectTypePropertiesContext.Provider;
export const ObjectTypePropertiesConsumer = ObjectTypePropertiesContext.Consumer;
export default ObjectTypePropertiesContext;